import React from "react";
import { connect } from "react-redux";
import { toggleSearchVisible, setSearchValue } from "../../../Redux/slices/search";
import DarkOverlay from "../../DarkOverlay";
import Search from "./Search";

const mapStateToProps = state => {
    return {
        visible: state.search.visible
    }
}

const mapDispatchToProps = dispatch => {
    return {
        toggleSearchVisible: payload => dispatch(toggleSearchVisible(payload))
    }
}

class MobileSearch extends React.Component {
    render() {
        return <DarkOverlay visible={this.props.visible} closeSelf={() => this.props.toggleSearchVisible(false)} belowNavBar={true}>
            <div className="search-wrap transform-fade-y fade-y-top">
                <Search visible={this.props.visible} />
            </div>
        </DarkOverlay>
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileSearch);